import { Link } from "react-router-dom";
import { CreditCard, FileText } from "lucide-react";

const input = "w-full rounded-lg border border-amber-900/20 bg-white px-3 py-2 text-sm outline-none focus:border-amber-deep";

export const chequeContactOk = (user, c) => {
  const src = user || c;
  const addrOk = Boolean(src?.address_line?.trim() && src?.city?.trim() && /^\d{5}$/.test((src?.postal_code || "").trim()));
  if (user) return addrOk;
  return addrOk && c.name.trim().length >= 2 && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email.trim()) && c.phone.replace(/\D/g, "").length >= 10;
};

function GuestFields({ contact, setContact }) {
  const set = (k) => (e) => setContact({ ...contact, [k]: e.target.value });
  return (
    <div data-testid="cheque-guest-fields" className="mt-3 grid grid-cols-2 gap-2">
      <input required aria-required="true" data-testid="cheque-name" placeholder="Nom et prénom *" value={contact.name} onChange={set("name")} className={`${input} col-span-2`} />
      <input required aria-required="true" data-testid="cheque-email" type="email" placeholder="E-mail *" value={contact.email} onChange={set("email")} className={`${input} col-span-2`} />
      <input required aria-required="true" data-testid="cheque-phone" type="tel" placeholder="Téléphone *" value={contact.phone} onChange={set("phone")} className={`${input} col-span-2`} />
      <input required aria-required="true" data-testid="cheque-address" placeholder="Adresse *" value={contact.address_line} onChange={set("address_line")} className={`${input} col-span-2`} />
      <input required aria-required="true" data-testid="cheque-postal" inputMode="numeric" maxLength={5} placeholder="Code postal *" value={contact.postal_code} onChange={(e) => setContact({ ...contact, postal_code: e.target.value.replace(/\D/g, "") })} className={input} />
      <input required aria-required="true" data-testid="cheque-city" placeholder="Ville *" value={contact.city} onChange={set("city")} className={input} />
      <p data-testid="cheque-required-hint" className="col-span-2 text-xs text-stone-mute">* Tous les champs sont obligatoires. Pays : France (le chèque est réservé aux résidents en France).</p>
    </div>
  );
}

function AccountAddress({ user, onNavigate }) {
  if (chequeContactOk(user)) {
    return <p data-testid="cheque-account-address" className="mt-2 text-xs text-bark-soft">Adresse en France : {user.address_line}, {user.postal_code} {user.city}</p>;
  }
  return (
    <p data-testid="cheque-account-missing" className="mt-2 text-xs font-medium text-terra">
      Le chèque est réservé aux résidents en France : <Link to="/compte" onClick={onNavigate} className="underline">renseignez votre adresse dans Mon compte</Link>.
    </p>
  );
}

export default function PaymentMethodPicker({ settings, method, setMethod, user, contact, setContact, onNavigate }) {
  const option = (id, Icon, label) => (
    <label className={`flex cursor-pointer items-center gap-3 rounded-xl border px-4 py-3 transition-colors ${method === id ? "border-amber-deep bg-amber-50" : "border-amber-900/15 bg-white"}`}>
      <input type="radio" name="payment-method" data-testid={`payment-method-${id}`} checked={method === id} onChange={() => setMethod(id)} className="accent-amber-deep" />
      <Icon size={16} className="text-amber-deep" />
      <span className="text-sm font-medium text-bark">{label}</span>
    </label>
  );
  return (
    <div data-testid="payment-methods" className="space-y-2">
      <p className="text-xs font-semibold uppercase tracking-[0.15em] text-stone-mute">Paiement</p>
      {option("card", CreditCard, "PayPal ou carte bancaire")}
      {option("cheque", FileText, "Chèque (résidents en France)")}
      {method === "cheque" && (
        <div data-testid="cheque-panel" className="rounded-xl border border-amber-800/15 bg-amber-50/60 px-4 py-3">
          <p data-testid="cheque-message" className="text-sm font-semibold text-bark">{settings.message}</p>
          <p className="mt-1 text-xs text-bark-soft">À l'ordre de <strong>{settings.payee}</strong>. L'adresse d'envoi vous sera indiquée après validation.</p>
          {user ? <AccountAddress user={user} onNavigate={onNavigate} /> : <GuestFields contact={contact} setContact={setContact} />}
        </div>
      )}
    </div>
  );
}
